import './index.css'
import { useState,useEffect } from 'react';
import FeedItem from '../feed-item'
import EmptyState from '../empty-state';
import IdeaItem from '../idea-item';
import PostIdea from '../post-idea';
import ScannedSite from '../scanned-site';
import LoadingState from '../loading-state';
import ExpandedIdeaItem from '../expanded-idea-item';
import { deleteIdea } from '../../functions/deleteIdea';
import { fetchStructuredIdea } from '../../functions/fetchStructureIdea';
import Button from '../button';
import CustomPostModule from '../custom-post-module';
import CrawlCountdown from '../crawl-countdown';

function FeedHolder({feedItems,context,handleClick,isLoaded,inputLength,openSiteAdder}){
    const [renderedFeedItems,setFeedItems] = useState([]);

    useEffect(() => {
        console.log("Incoming feedItems:", feedItems);
        setFeedItems(feedItems);
    }, [feedItems]);

    const [displayOfExpandedIdea,SetDisplayOfExpandedIdea] = useState('none');

    const [expandedIdea,SetExpandedIdea] = useState({
        "title":"",
        "structure": '',
        "id" : "",
        "image" :null
    });

    useEffect(async() => {
        const urlParams = new URLSearchParams(new URL(document.location).search);
        const id = urlParams.get('id');
        if(id){
           const data = await fetchStructuredIdea(id);
           if(data.foundObject&&data.foundObject.ideaType === "blog"){
            console.log(data.foundObject);
            SetExpandedIdea(data.foundObject);
            SetDisplayOfExpandedIdea('block');
           }
           if(data.foundObject&&data.foundObject.ideaType === "post"){
            SetExpandedIdea({
                "id": data.foundObject.id,
                "title": `${data.foundObject.generatedFrom}`,
                "generatedFrom": data.foundObject.generatedFrom,
                "stage": data.foundObject.status,
                "structure": data.foundObject.content,
                "scheduledDate": data.foundObject.scheduledDate,
                "image" : data.foundObject.image
            })
            SetDisplayOfExpandedIdea('block');
           }
           else{
            const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            // Use the history API to update the URL
            window.history.replaceState({ path: newUrl }, '', newUrl);
           }
        }
    }, [])


    const expandIdea = (index) =>{ 
        SetDisplayOfExpandedIdea('block');
    }

    const closeIdea = () => {
        SetDisplayOfExpandedIdea('none');
        SetExpandedIdea({
            "title":"",
            "structure": '',
            "id" : "",
        })
        
        const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        // Use the history API to update the URL
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }

    const handleDeleteRequest = (id) => {
        deleteIdea(id);
        const index = renderedFeedItems.findIndex(item => item.id === id);
        if (index !== -1) {
            const newFeedItems = [...renderedFeedItems];
            newFeedItems.splice(index, 1); // Remove the item
            setFeedItems(newFeedItems);
        }
    }


const downloadToCsv = () => {
    if (renderedFeedItems.length === 0) {
        console.log("Not enough to download!");
        return;
    }

    const items = renderedFeedItems;
    const excludedFields = ['hasBeenSeen', 'tag','placeholder'];

    // Generate header excluding specified fields
    const header = Object.keys(items[0]).filter(key => !excludedFields.includes(key));
    
    // Convert to CSV string
    const replacer = (key, value) => value === null ? '' : value;
    const csv = [
        header.join(','), // header row
        ...items.map(row =>
            header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(',')
        )
    ].join('\r\n');

    // Create and trigger download
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'mako-data.csv';
    a.click();
    URL.revokeObjectURL(url);
};

    const secondaryButtonStatus = {
        "feed" : {image:"../images/download.png", text:"Download CSV", functionOnClick:downloadToCsv},
    }


    let feedHTML;
    if(!isLoaded){
        feedHTML=<LoadingState />
    }
    else{

    if(renderedFeedItems.length===0){
        let message;
        switch (context) {
            case 'ideas':
                message = 'No ideas generated yet...';
                break;
            case 'feed':
                if(inputLength===0){
                    message = 'Add sites to generate your feed...';
                }
                if(inputLength>0){
                    message = "We're monitoring your sites for posts...";
                }
                break;
            case 'scan':
                message = 'No sites added yet...';
                break;
            default:
                message = 'Nothing to see here...';
                break;
        }
        feedHTML= <EmptyState message={message} openSiteAdder={openSiteAdder}/>
    }
    
    else{
        if(context==='feed'){
            let columnA = [];
            let columnB = [];
            let columnC = [];
            let mobileColumn = [];
            let ticker = 0;
            for(let i=0;i<renderedFeedItems.length;i++){
                let item = renderedFeedItems[i];
                mobileColumn.push( <FeedItem
                    date={item.date}
                    tag={item.tag}
                    image={item.image}
                    desc={item.excerpt}
                    hasBeenSeen={item.hasBeenSeen}
                    site={item.site}
                    title={item.title}
                    index={i}
                    url={item.url} 
                    placeholder={item.placeholder}
                    /> )
                let index = i;
                switch(ticker){
                    case 0:
                        columnA.push( <FeedItem
                        date={item.date}
                        tag={item.tag}
                        image={item.image}
                        desc={item.excerpt}
                        hasBeenSeen={item.hasBeenSeen}
                        site={item.site}
                        title={item.title}
                        index={index}
                        url={item.url} 
                        placeholder={item.placeholder}
                        /> )
                        ticker++;
                    break;
                    case 1:
                        columnB.push( <FeedItem
                        date={item.date}
                        tag={item.tag}
                        image={item.image}
                        desc={item.excerpt}
                        hasBeenSeen={item.hasBeenSeen}
                        site={item.site}
                        title={item.title}
                        index={index}
                        url={item.url} 
                        placeholder={item.placeholder}
                        /> )
                        ticker++;
                    break;
                    case 2:
                        columnC.push( <FeedItem
                        date={item.date}
                        tag={item.tag}
                        image={item.image}
                        desc={item.excerpt}
                        hasBeenSeen={item.hasBeenSeen}
                        site={item.site}
                        title={item.title}
                        index={index}
                        url={item.url} 
                        placeholder={item.placeholder}
                        /> )
                        ticker=0;
                    break;
                }
            }
            let documentWidth = document.body.clientWidth;
            if(documentWidth >= 800){
                feedHTML = <><div className='tile-column'>{columnA}</div><div className='tile-column'>{columnB}</div><div className='tile-column'>{columnC}</div></>
            }
            if(documentWidth < 800){
                feedHTML = <><div className='tile-column'>{mobileColumn}</div></>
            }
    }
        if(context==='ideas'){
            feedHTML = renderedFeedItems.map((item, index) => {
                if(item.ideaType === "blog"){
                    return ( 
                        <IdeaItem
                        date={item.dateAdded}
                        title={item.title}
                        status={item.stage}
                        type={item.ideaType}
                        generatedFrom={item.generatedFrom}
                        id={item.id}
                        scheduledDate={item.scheduledDate}
                        display={displayOfExpandedIdea}
                        expandIdea={expandIdea}
                        SetExpandedIdea={SetExpandedIdea}
                        SetFeedItems={setFeedItems}
                        handleDeleteRequest={handleDeleteRequest}
                        />
                        )
                }
                if(item.ideaType === "post"){
                    return ( 
                        <PostIdea
                        date={item.dateAdded}
                        imageContent={item.imageContent}
                        content={item.content}
                        status={item.stage}
                        type={item.ideaType}
                        generatedFrom={item.generatedFrom}
                        id={item.id}
                        image={item.image}
                        scheduledDate={item.scheduledDate}
                        display={displayOfExpandedIdea}
                        expandIdea={expandIdea}
                        SetExpandedIdea={SetExpandedIdea}
                        SetFeedItems={setFeedItems}
                        handleDeleteRequest={handleDeleteRequest}
                        />
                        )
                }

        })
        }
        if(context==='scan'){
            feedHTML = renderedFeedItems.map((item, index) => {
                return ( 
                <ScannedSite
                domain={item.domain}
                status={item.status}
                handleClick={handleClick}
                dateAddedByUser={item.dateAddedByUser}
                />
                )
        })
        }        
    }
}
    return <>
{secondaryButtonStatus[context] && (<div id="download-holder"><CrawlCountdown /><Button text={secondaryButtonStatus[context].text} image={secondaryButtonStatus[context].image} addedFunction={secondaryButtonStatus[context].functionOnClick} /></div>)}    
<div className="feed-holder">
    {feedHTML}
    <ExpandedIdeaItem  renderedFeedItems={renderedFeedItems} setFeedItems={setFeedItems} display={displayOfExpandedIdea} title={expandedIdea.title} structure={expandedIdea.structure} close={closeIdea} id={expandedIdea.id} date={expandedIdea.scheduledDate} image={expandedIdea.image}></ExpandedIdeaItem>
    </div>
    </> 
}

export default FeedHolder